export default __webpack_public_path__ + "static/fax_compare_comp1_inactive-691522454102db66e8463d5402986878.png";